import { FC } from "react";

import dynamic from "next/dynamic";

import { NextLinkProps } from "./types";

// Disabled SSR to avoid memory leak caused by makeStyles
export const NextLink = dynamic(() => import("./NextLinkSsr").then((mod) => mod.NextLinkSsr), {
  ssr: false,
}) as FC<NextLinkProps>;
